import axios from 'axios';
import actions from '../actions/checking';

export default {
	namespaced: true,
	state: {
		entities: [],
		links: [],
		paginationMetadata: {},
	},
	mutations: {
		[actions.SET_DATA]: (state, data) => {
			state.links = data.links;
			state.entities = data.entities;
			state.paginationMetadata = data.paginationMetadata;
		},
		[actions.REMOVE_DATA]: (state) => {
			state.links = [];
			state.entities = [];
			state.paginationMetadata = {};
		},
	},
	actions: {
		[actions.GET_CHECKING]: async ({ commit }, checkingRequest) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(`perfdb/performancelist/${checkingRequest.masterOrgId}/${checkingRequest.perfId}`);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_CHECKING]: async ({ commit }, link) => {
			try {
				commit(actions.REMOVE_DATA);

				const response = await axios.get(link.href);

				const { data } = response;

				data.entities.forEach((entity) => {
					entity.id = `${entity.id}`;
				});

				commit(actions.SET_DATA, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.CREATE_NEW_CHECKING]: async (context, { newChecking, link }) => {
			try {
				await axios.post(link.href, newChecking);
			} catch (error) {
				throw error;
			}
		},
		[actions.UPDATE_CHECKING]: async (context, {
			status,
			reason,
			perfId,
			perfListId,
			userId,
		}) => {
			try {
				const patch = [
					{
						op: 'replace',
						path: '/checkingState',
						value: status,
					},
					{
						op: 'replace',
						path: '/reason',
						value: reason,
					},
				];

				await axios.patch(
					`perfdb/checking/${perfListId}/${perfId}/${userId}`,
					patch, {
						headers: { 'Content-Type': 'application/json-patch+json' },
					},
				);
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		Entities: state => state.entities,
		Links: state => state.links,
		Pagination: state => state.paginationMetadata,
	},
};
